import axiosInstance from './axiosConfig';

export const getTicketsApi = (params) => axiosInstance.get('/tickets', { params });
export const getTicketApi = (id) => axiosInstance.get(`/tickets/${id}`);
export const createTicketApi = (payload) => axiosInstance.post('/tickets', payload);
export const replyToTicketApi = (id, message) =>
  axiosInstance.post(`/tickets/${id}/reply`, { message });
export const updateTicketStatusApi = (id, status) =>
  axiosInstance.put(`/tickets/${id}/status`, { status });